module.exports = __webpack_public_path__ + "img/female.0622c992.png";